(function () {
  'use strict';

  var COOKIE_NAME = 'legaz_popup_seen';
  var PENDING_FLAG = 'legaz_popup_pending';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^|; )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  function setCookie(name, value, days) {
    var expires = new Date();
    expires.setTime(expires.getTime() + days * 86400000);
    document.cookie = name + '=' + value + '; expires=' + expires.toUTCString() + '; path=/; SameSite=Lax';
  }

  function shouldSuppressPath() {
    var p = window.location.pathname;
    if (p.indexOf('/account') === 0) return true;
    if (p.indexOf('/cart') === 0) return true;
    if (p.indexOf('/checkout') === 0) return true;
    if (p.indexOf('/challenge') === 0) return true;
    return false;
  }

  function init() {
    var popup = document.getElementById('legaz-popup');
    if (!popup) return;

    var form = popup.querySelector('form');
    var lastForm = '';
    var hadPending = false;
    try { lastForm = sessionStorage.getItem('legaz_last_submitted_form') || ''; } catch (_) {}
    try { hadPending = sessionStorage.getItem(PENDING_FLAG) === '1'; } catch (_) {}

    var postSubmit = lastForm === 'popup';

    if (postSubmit) {
      try { sessionStorage.removeItem('legaz_last_submitted_form'); } catch (_) {}
      try { sessionStorage.removeItem(PENDING_FLAG); } catch (_) {}
    } else {
      // If a different form was just submitted, Shopify rendered our
      // form.posted_successfully? success message too. Strip it so the
      // popup doesn't open with a misleading message later.
      if (lastForm) {
        popup.querySelectorAll('[role="status"], [role="alert"]').forEach(function (el) {
          el.remove();
        });
      }
      if (hadPending) {
        try { sessionStorage.removeItem(PENDING_FLAG); } catch (_) {}
      } else {
        if (shouldSuppressPath()) return;
        if (getCookie(COOKIE_NAME)) return;
      }
    }

    var displayMode = popup.dataset.display || 'flyout';
    var triggerType = popup.dataset.trigger || 'click';

    var delay = parseInt(popup.dataset.triggerDelay, 10);
    if (!delay || delay < 1) delay = 15;

    var cookieDays = parseInt(popup.dataset.cookieDays, 10);
    if (!cookieDays || cookieDays < 1) cookieDays = 30;

    var successText = popup.dataset.successText || 'subscribed, check your email.';
    var lastFocus = null;
    var openedAlready = false;

    var FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function getFocusable() {
      return Array.prototype.filter.call(
        popup.querySelectorAll(FOCUSABLE_SELECTOR),
        function (el) {
          return el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0;
        }
      );
    }

    // Keep Tab and Shift+Tab cycling inside the dialog while it is open
    function trapFocus(e) {
      var focusable = getFocusable();
      if (focusable.length === 0) {
        e.preventDefault();
        return;
      }
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      var active = document.activeElement;
      var inside = popup.contains(active);

      if (e.shiftKey) {
        if (!inside || active === first || active === popup || active === card()) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (!inside || active === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    function card() {
      return popup.querySelector('.legaz-popup__card') || popup;
    }

    function ensureMessage() {
      if (popup.querySelector('[role="status"], [role="alert"]')) return;
      if (!form) return;
      var div = document.createElement('div');
      div.className = 'legaz-popup__msg';
      div.setAttribute('role', 'status');
      div.textContent = successText;
      form.appendChild(div);
    }

    function open() {
      if (openedAlready) return;
      openedAlready = true;
      lastFocus = document.activeElement;
      popup.removeAttribute('hidden');
      popup.setAttribute('data-state', 'open');
      popup.setAttribute('aria-hidden', 'false');
      if (displayMode === 'modal') {
        document.body.style.overflow = 'hidden';
      }
      setCookie(COOKIE_NAME, String(Date.now()), cookieDays);
      // Move focus to the dialog container instead of yanking it into the
      // email input; the heading is announced via aria-labelledby.
      var dialogCard = card();
      if (!dialogCard.hasAttribute('tabindex')) {
        dialogCard.setAttribute('tabindex', '-1');
      }
      try { dialogCard.focus({ preventScroll: true }); } catch (_) { dialogCard.focus(); }
    }

    function close() {
      if (popup.getAttribute('data-state') !== 'open') return;
      popup.removeAttribute('data-state');
      popup.setAttribute('aria-hidden', 'true');
      popup.setAttribute('hidden', '');
      if (displayMode === 'modal') {
        document.body.style.overflow = '';
      }
      if (lastFocus && typeof lastFocus.focus === 'function') {
        try { lastFocus.focus({ preventScroll: true }); } catch (_) { lastFocus.focus(); }
      }
    }

    popup.addEventListener('click', function (e) {
      if (e.target.closest('.legaz-popup__close')) {
        e.preventDefault();
        close();
        return;
      }
      if (displayMode === 'modal' && !e.target.closest('.legaz-popup__card')) {
        close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (popup.getAttribute('data-state') !== 'open') return;
      if (e.key === 'Escape') {
        close();
        return;
      }
      if (e.key === 'Tab') {
        trapFocus(e);
      }
    });

    if (form) {
      form.addEventListener('submit', function () {
        if (form.checkValidity && !form.checkValidity()) return;
        try { sessionStorage.setItem('legaz_last_submitted_form', 'popup'); } catch (_) {}
      });
    }

    function armClickTrigger() {
      var clickHandler = function (e) {
        if (popup.contains(e.target)) return;
        document.removeEventListener('click', clickHandler, true);

        // If the first click is a same-tab navigation link, don't open
        // here (the page is about to change and the popup would just
        // flash). Save a pending flag so the next page picks it up.
        var anchor = e.target.closest('a[href]');
        var willNavigate = anchor &&
                           anchor.target !== '_blank' &&
                           !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;

        if (willNavigate) {
          try { sessionStorage.setItem(PENDING_FLAG, '1'); } catch (_) {}
        } else {
          open();
        }
      };
      document.addEventListener('click', clickHandler, true);
    }

    if (postSubmit) {
      ensureMessage();
      open();
      return;
    }

    if (hadPending) {
      open();
      return;
    }

    if (triggerType === 'click') {
      armClickTrigger();
    } else if (triggerType === 'delay') {
      setTimeout(open, delay * 1000);
    } else {
      armClickTrigger();
      setTimeout(open, delay * 1000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
